import classNames from 'classnames';
import { Button } from 'yoso';
import { ErrorFallbackProps } from '~/components/Error';
import { ErrorMessage } from '~/components/Error/Message';
import { t, T } from '~/components/I18n';

export type LevelUpErrorFallbackProps = ErrorFallbackProps & {
  className?: string;
};
export const LevelUpErrorFallback = ({
  className,
  resetErrorBoundary,
}: LevelUpErrorFallbackProps) => (
  <ErrorMessage
    className={classNames('level-up-error-message', className)}
    title={<T name="citizen_error_etc_title" />}
    description={<T name="citizen_error_etc_desc" />}>
    <Button
      className="level-up-error-message-button"
      size="large"
      color="secondary"
      onClick={resetErrorBoundary}>
      {t('citizen_okbutton')}
    </Button>
  </ErrorMessage>
);
